import React from 'react';
import RichText from '../../../../../../hoc/components/rich-text';
import InformationPanel from '../../../../../../hoc/components/information-panel';
import useTranslation from '../../../../../../../hooks/useTranslation';

const ConfirmationHeaderBottom: React.FC = () => {
	const { t } = useTranslation();

	return (
		<InformationPanel>
			<RichText html={t('pages.confirmation.header.more')} />
		</InformationPanel>
	);
};

export default ConfirmationHeaderBottom;
